import styles from "../style.module.css";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "../api/config";
import Spinner from 'react-bootstrap/Spinner';
//import { Link } from "react-router-dom";

function Price() {

  const { isError, isLoading, data, error } = useQuery({
    queryKey: ['prcing'],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/api/user/pages/pricing`);
      return await res.json();
    },
  })


  if (isLoading) {
    return <div className="d-flex flex-column justify-content-center justify-content-center align-items-center" style={{ height: "50vh" }}>
      <Spinner animation="border" role="status" style={{ height: "89px", width: "89px" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-3">Kindly be patient while we fetch your data</p>
    </div>
  }

  if (isError) {
    return (
      <p>An Error Occurred : {error.message}</p>
    )
  }

  return (
    <div className={styles.price}>
      <div className={`container ${styles.priceContent}`}>
        <h3 className={`text-center ${styles.headerText4}`}>
          Choose a subcription plan
        </h3>
        <div className="row">

          {
            data?.metadata.map(d => {
              return <div className="col-12 col-lg-6" key={d?.title}>
                <div className={`card ${styles.priceCard}`}>
                  <div className="card-body">
                    <h5 className="card-title mt-3 price-header">{d?.title}</h5>
                    <div className="price-amount">
                      <div className={`card-text ${styles.amt}`}>₦{Number(d?.monthlyFee).toLocaleString('en-NG', { maximumFractionDigits: 0 })}/ Month</div>
                      <div className={`card-text ${styles.month}`}>
                        ₦{Number(d?.annualFee).toLocaleString('en-NG', { maximumFractionDigits: 0 })} Annually
                      </div>
                    </div>
                    <hr />
                    <div className={`card-text ${styles.ulCover}`}>
                      <p className={`card-text ${styles.priceDesc}`}>
                        {d?.description}
                      </p>
                      <ul className="ul">
                        {d?.peeks?.map(p => {
                          return <li key={p}>
                            {p}<span className="ml-3">&#10004;</span>
                          </li>
                        })}
                      </ul>
                    </div>
                    <a href="https://account.aaerlaw.com/account/register" className={styles.regLink}>
                      Get Started
                    </a>
                  </div>
                </div>
              </div>
            })
          }
          {/* <div className="col-12 col-lg-6">
            <div className={`card ${styles.priceCard}`}>
              <div className="card-body">
                <h5 className="card-title mt-3 price-header">Basic</h5>
                <div className="price-amount">
                  <div className={`card-text ${styles.amt}`}>₦2,500/ Month</div>
                  <div className={`card-text ${styles.month}`}>
                    ₦25,000 Annually
                  </div>
                </div>
                <hr />
                <div className={`card-text ${styles.ulCover}`}>
                  <p className={`card-text ${styles.priceDesc}`}>
                    The fundamental plan to get you started and increase your
                    productivity as a legal Practitioner
                  </p>
                  <ul className="ul">
                    <li>
                      Law Report<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Laws of the federation<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Regulations of MDA<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Rules of court<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Textbooks<span className="ml-3">&#10004;</span>
                    </li>
                  </ul>
                </div>
                <a href="https://account.aaerlaw.com/account/register" className={styles.regLink}>
                  Get Started
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 sp-top">
            <div className={`card ${styles.priceCard}`}>
              <div className="card-body">
                <h5 className="card-title mt-3 price-header">Professional</h5>
                <div className="price-amount">
                  <div className={`card-text ${styles.amt}`}>₦4,000/ Month</div>
                  <div className={`card-text ${styles.month}`}>
                    ₦40,000 Annually
                  </div>
                </div>
                <hr />
                <div className={`card-text ${styles.ulCover}`}>
                  <p className={`card-text ${styles.priceDesc}`}>
                    Get Access to Basic feature and all the new features coming
                    on AAER
                  </p>
                  <ul className="ul">
                    <li>
                      Law Reports<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Laws of the federation<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Regulations of MDA<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Rules of court<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Textbooks<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Precedents<span className="ml-3">&#10004;</span>
                    </li>
                    <li>
                      Journal articles<span className="ml-3">&#10004;</span>
                    </li>
                  </ul>
                </div>
                <a href="https://account.aaerlaw.com/account/register" className={styles.regLink}>
                  Get Started
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Price;
